// src/config/api.js
export const API_BASE_URL = 'https://cleaner-automation-936dbbf97f9e.herokuapp.com';

export const endpoints = {
  // Existing endpoints
  checkQuestion: '/api/check-question',
  getAnswer: '/api/get-answer',
  updateAnswer: '/api/update-answer',
  addQnA: '/api/add-qna',
  scrapeWebsite: '/api/scrape-website',
  purchasePhoneNumber: '/api/phone-numbers/purchase',
  finalizeSetup: '/api/account/setup',
  generateVariations: '/api/generate-variations',
  updatePathway: '/api/update-pathway',
  generateTriggers: '/api/generate-triggers',
  generateQuestions: '/api/generate-questions',
  generateSopIntent: '/api/generate-sop-intent',
  updateVoicePreference: '/api/update-voice-preference',
  generateStaticMap: '/api/generate-static-map',
  generateLocationZipcodes: '/api/generate-location-zipcodes',

  // Add new SOP endpoints
  updateSopPathway: '/api/update-sop-pathway',

  //Onboarding
  searchPhoneNumbers: '/api/phone-numbers/search',
  verifyWebsite: '/api/website/verify',
  duplicatePathway: '/api/pathways/duplicate-default',
  scrapeLocationData: '/api/account/scrape/location-business-data',
  knowledgeQuery: '/api/onboarding/integration/knowledge',

  //Payments with Stripe
  createPaymentIntent: '/api/create-payment-intent',
};